module.exports = __webpack_public_path__ + "static/images/index-vip-banner-title-1.png?v=c6e41aa";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/images/index-vip-banner-title-1.png
// module id = vaEC
// module chunks = 1